<div #mainDiv_ll_exam_sections_scope>
  <!-- Scrollable Question List -->
  <div *ngIf="bundle.showPanel && bundle.questionList.length > 0"
       class="question-list"
       [style.width.px]="bundle.panelW"
       [style.height.px]="bundle.panelH"
       style="overflow-y: auto; overflow-x: hidden; padding: 10px 0;">

    <div *ngFor="let q of bundle.questionList; let i = index" class="question-item">

      <!-- PROSPECT COMPANY -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.PROSPECT_COMPANY_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="editCompany(q, 'PROSPECT')">Edit</span>
      </div>

      <!-- LENDER COMPANY -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.LENDER_COMPANY_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="editCompany(q, 'LENDER')">Edit</span>
      </div>

      <!-- EXAMINER COMPANY -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.EXAMINER_COMPANY_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="editCompany(q, 'EXAMINER')">Edit</span>
      </div>

      <!-- PROSPECT CONTACTS -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.PROSPECT_CONTACT_TABLE_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openContactsModal(q, 'PROSPECT')">Edit</span>
      </div>

      <!-- LENDER CONTACTS -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.LENDER_CONTACT_TABLE_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openContactsModal(q, 'LENDER')">Edit</span>
      </div>

      <!-- EXAMINER CONTACTS -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.EXAMINER_CONTACT_TABLE_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openContactsModal(q, 'EXAMINER')">Edit</span>
      </div>

      <!-- PROSPECT COMPANY DESCRIPTION -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.PROSPECT_COMPANY_DESC_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openDescriptionEditor(q)">Edit</span>
      </div>

      <!-- PROSPECT COMPANY WEB PAGE -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.PROSPECT_COMPANY_WEBURL_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openContactsModal(q, 'EXAMINER')">Edit</span>
      </div>

      <!-- EXAM PARAMETERS DISPLAY -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.EXAMPARAMS_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openExamParamsModal(q)">Edit</span>
      </div>

      <!-- CREDIT FACILITY DISPLAY -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.CREDITFACILITY_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openExamParamsModal(q)">Edit</span>
      </div>

      <!-- LOCATION TABLE -->
      <!--<div class="company-html">
        <div class="company-content" [innerHTML]="q.LOCATION_TABLE_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openLocationsModal(q)">Edit</span>
      </div>-->

      <div class="question-divider"></div>
    </div>
  </div>

  <!-- ==================== MAIN CONTACT SELECTION MODAL ==================== -->
  <div *ngIf="showContactModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1000;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 600px;
                max-height: 80vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
      <div style="padding: 16px; border-bottom: 1px solid #e0e0e0; display: flex;
                  justify-content: space-between; align-items: center; background: #f8f8f8;
                  border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <h3 style="margin: 0; font-size: 18px; color: #003399;">{{ modalTitle }}</h3>
        <div>
          <span class="wordBtn" (click)="openAddContactModal()" style="margin-right: 20px; cursor: pointer;">
            + Add Contact
          </span>
          <button (click)="closeContactModal()"
                  style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666; line-height: 1;">
            ×
          </button>
        </div>
      </div>
      <div style="padding: 16px;">
        <div *ngFor="let contact of getContactChoices()"
             style="display: flex; align-items: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; cursor: pointer;">
          <label style="display: flex; align-items: center; width: 100%; user-select: none;">
            <input type="checkbox"
                   [checked]="isContactSelected(contact.CONTACTID)"
                   (change)="toggleContact(contact.CONTACTID)"
                   style="margin-right: 16px; width: 18px; height: 18px; accent-color: #003399;" />
            <span style="flex: 1; font-size: 14px;">
              {{ contact.DISPLAY }}
            </span>
          </label>
        </div>
        <div *ngIf="getContactChoices().length === 0"
             style="text-align: center; color: #999; padding: 40px 0;">
          No contact choices available
        </div>
      </div>
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; text-align: right; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
        <button (click)="closeContactModal()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;
                       cursor: pointer; font-size: 14px;">
          Close
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== ADD NEW CONTACT MODAL ==================== -->
  <div *ngIf="showAddContactModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.6); z-index: 1100;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 480px; box-shadow: 0 6px 25px rgba(0,0,0,0.4);">
      <div style="padding: 20px; border-bottom: 1px solid #e0e0e0; background: #f8f8f8; border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <h3 style="margin: 0; color: #003399;">Add New {{ modalType }} Contact</h3>
      </div>
      <div style="padding: 25px;">
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px;">Title: <span style="color:red;">*</span></label>
          <input type="text" [(ngModel)]="newContact.CONTACTTITLE" autocomplete="new-password"
                 style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">
        </div>
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px;">First Name: <span style="color:red;">*</span></label>
          <input type="text" [(ngModel)]="newContact.CONTACTFIRST" autocomplete="new-password"
                 style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">
        </div>
        <div style="margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px;">Last Name: <span style="color:red;">*</span></label>
          <input type="text" [(ngModel)]="newContact.CONTACTLAST" autocomplete="new-password"
                 style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">
        </div>
        <div style="margin-bottom: 20px;">
          <label style="display: block; margin-bottom: 5px;">Email: <span style="color:red;">*</span></label>
          <input type="email" [(ngModel)]="newContact.CONTACTEMAIL" autocomplete="new-password"
                 style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">
        </div>
      </div>
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; text-align: right; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
        <button (click)="closeAddContactModal()"
                style="margin-right: 12px; padding: 10px 20px; background: #666; color: white; border: none; border-radius: 4px;">
          Cancel
        </button>
        <button (click)="saveNewContact()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;">
          Save Contact
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== PROSPECT COMPANY DESCRIPTION EDITOR MODAL ==================== -->
  <div *ngIf="showDescriptionModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.6); z-index: 1200;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 800px; max-height: 85vh;
                display: flex; flex-direction: column; box-shadow: 0 8px 30px rgba(0,0,0,0.4);">

      <!-- Header -->
      <div style="padding: 16px 20px; border-bottom: 1px solid #e0e0e0; background: #f8f8f8;
                  border-top-left-radius: 8px; border-top-right-radius: 8px; display: flex; justify-content: space-between; align-items: center;">
        <h3 style="margin: 0; color: #003399;">Edit Prospect Company Description</h3>
        <button (click)="closeDescriptionModal()"
                style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666;">
          ×
        </button>
      </div>

      <!-- Editor Area -->
      <div style="flex: 1; padding: 20px; overflow: auto;">
        <div #descriptionEditor
             contenteditable="true"
             (input)="onDescriptionChange()"
             style="width: 100%; min-height: 350px; border: 1px solid #ccc; border-radius: 4px;
                    padding: 15px; font-size: 14px; line-height: 1.6; outline: none; background: white;">
        </div>
      </div>

      <!-- Footer -->
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; text-align: right;">
        <button (click)="closeDescriptionModal()"
                style="margin-right: 12px; padding: 10px 20px; background: #666; color: white; border: none; border-radius: 4px;">
          Cancel
        </button>
        <button *ngIf="descriptionHasChanged" (click)="saveDescriptionChanges()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;">
          Save Changes
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== LOCATIONS SELECTION MODAL ==================== -->
  <div *ngIf="showLocationModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1000;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 600px;
                max-height: 80vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
      <div style="padding: 16px; border-bottom: 1px solid #e0e0e0; display: flex;
                  justify-content: space-between; align-items: center; background: #f8f8f8;
                  border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <h3 style="margin: 0; font-size: 18px; color: #003399;">Exam Locations</h3>
        <button (click)="closeLocationsModal()"
                style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666; line-height: 1;">
          ×
        </button>
      </div>
      <div style="padding: 16px;">
        <div *ngFor="let loc of getLocationChoices()"
             style="display: flex; align-items: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; cursor: pointer;">
          <label style="display: flex; align-items: center; width: 100%; user-select: none;">
            <input type="checkbox"
                   [checked]="isLocationSelected(loc.LOCATIONID)"
                   (change)="toggleLocation(loc.LOCATIONID)"
                   style="margin-right: 16px; width: 18px; height: 18px; accent-color: #003399;" />
            <span style="flex: 1; font-size: 14px;">
              {{ loc.DISPLAY }}
            </span>
          </label>
        </div>
        <div *ngIf="getLocationChoices().length === 0"
             style="text-align: center; color: #999; padding: 40px 0;">
          No location choices available
        </div>
      </div>
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; text-align: right; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
        <button (click)="closeLocationsModal()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;
                       cursor: pointer; font-size: 14px;">
          Close
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== EXAM PARAMETERS MODAL ==================== -->
  <div *ngIf="showExamParamsModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1000;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 600px;
                max-height: 85vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">

      <div style="padding: 16px; border-bottom: 1px solid #e0e0e0; display: flex;
                  justify-content: space-between; align-items: center; background: #f8f8f8;
                  border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <h3 style="margin: 0; font-size: 18px; color: #003399;">Exam Parameters</h3>
        <button (click)="closeExamParamsModal()"
                style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666; line-height: 1;">
          ×
        </button>
      </div>

      <div style="padding: 25px; display: flex; flex-direction: column; gap: 20px;">

        <!-- Through Month -->
        <div>
          <label style="display: block; margin-bottom: 6px; font-weight: 500;">Through:</label>
          <select [(ngModel)]="tempExamThrough" style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
            <option value="">Select...</option>
            <option *ngFor="let m of bundle.monthEndChoices" [value]="m.FORMAT_ISO">
              {{ m.FORMAT_ISO }}
            </option>
          </select>
        </div>

        <!-- Months Back -->
        <div>
          <label style="display: block; margin-bottom: 6px; font-weight: 500;">Months Back:</label>
          <select [(ngModel)]="tempExamMonthsBack" style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
            <option value="">Select...</option>
            <option *ngFor="let n of [2,3,4,5,6,7,8]" [value]="n">{{ n }}</option>
          </select>
        </div>
      </div>

      <div style="padding: 16px; border-top: 1px solid #e0e0e0; text-align: right; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
        <button (click)="closeExamParamsModal()"
                style="margin-right: 12px; padding: 10px 20px; background: #666; color: white; border: none; border-radius: 4px;">
          Cancel
        </button>
        <button (click)="saveExamParamsModal()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;">
          Save Changes
        </button>
      </div>
    </div>
  </div>

</div>
